import { render, staticRenderFns } from "./ClassCard.vue?vue&type=template&id=b0a5c330&scoped=true&"
import script from "./ClassCard.vue?vue&type=script&lang=js&"
export * from "./ClassCard.vue?vue&type=script&lang=js&"
import style0 from "./ClassCard.vue?vue&type=style&index=0&id=b0a5c330&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a5c330",
  null
  
)

export default component.exports